import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import './RecuperationDonnees.css';

import recuperationDonneesImage from '../images/Récupération-de-données-à-Nantes.webp';

const RecuperationDonnees = () => {
  return (
    <>
      <Helmet>
        <title>Expert en récupération de données informatiques à Nantes et sa métropole</title>
        <meta name="description" content="Expert en récupération de données informatiques à Nantes et sa métropole. Upgrade Informatique, spécialiste récupération données sur disques durs, clés USB, cartes mémoire à Rezé." />
        <meta name="keywords" content="récupération données, Nantes, Rezé, disques durs, clés USB, cartes mémoire, Upgrade Informatique, RESCUE SYSTEM, RESCUE DATA" />
      </Helmet>
      
      <div className="page-content">
        <div className="container">
          <article className="page-article">
            <div className="entry-content">
              <h1>Expert en récupération de données informatiques à Nantes et sa métropole</h1>
              
              <h2>Faites confiance à Upgrade Informatique pour récupérer vos données sensibles à Rezé, proche de Nantes</h2>
              
              <p>
                <strong><Link to="/">Upgrade Informatique</Link></strong> est votre expert local spécialisé dans la <Link to="/blog/carte-mere-hs-reparer-ou-remplacer-verdict-2025" className="blog-link"><strong>récupération professionnelle de données</strong></Link> sur tous supports numériques endommagés : disques durs, clés USB, cartes mémoire et leur transfert sécurisé vers un nouveau support.
              </p>

              <p>
                Une suppression malencontreuse de fichiers critiques vous préoccupe ?
              </p>

              <p>
                Une panne inattendue de votre ordinateur vous empêche d'accéder à vos documents essentiels ?
              </p>

              <p>
                Nous avons les solutions techniques pour récupérer vos données précieuses.
              </p>

              <div className="image-caption">
                <img 
                  src={recuperationDonneesImage} 
                  alt="Récupération de données professionnelle"
                  className="content-image"
                />
              </div>

              <h3 className="green-title">
                <span>Nos solutions expertes de récupération de données à Rezé dans l'agglomération nantaise</span>
              </h3>
              
              <p>
                Face à une défaillance de votre ordinateur et un <Link to="/blog/combien-coute-reparer-carte-mere-7-prix-reels-2025" className="blog-link"><strong>disque dur défectueux</strong></Link>, gardez votre calme.
              </p>

              <p>
                Nos experts disposent de solutions techniques avancées pour sauvegarder vos données.
              </p>

              <p>
                Nous vous proposons deux approches professionnelles complémentaires :
              </p>

              <div className="solutions-table">
                <div className="solution-row">
                  <div className="solution-cell">
                    <div>
                      <strong>Solution RESCUE SYSTEM Premium</strong>
                      <p>Cette intervention experte permet de sauvegarder votre système Windows complet depuis le disque défaillant et de le transférer sur un nouveau support, tout en intégrant les optimisations de performances SPEED UP (détaillées dans notre section reconditionnement).</p>
                    </div>
                    <span></span>
                  </div>
                  <div className="solution-cell price">249 €</div>
                </div>
                
                <div className="solution-row">
                  <div className="solution-cell">
                    <div>
                      <strong>Solution RESCUE DATA Avancée</strong>
                      <p>Dans les cas où la première approche n'est pas réalisable, nous effectuons une analyse approfondie du support endommagé avec nos outils spécialisés pour récupérer l'intégralité de vos fichiers importants.</p>
                    </div>
                    <span></span>
                  </div>
                  <div className="solution-cell price">179 €</div>
                </div>
              </div>

              <p>
                Découvrez également notre gamme complète de services : <strong><u>assistance informatique personnalisée</u></strong>, <strong><u>reconditionnement professionnel</u></strong> et <u><strong>support technique à distance</strong></u> !
              </p>

              <div className="contact-cta">
                <h2>Besoin de récupérer vos données perdues ?</h2>
                <p>Solutions expertes pour tous types de supports endommagés</p>
                <p>Contactez Upgrade Informatique au <Link to="/contact" className="phone-link">Contactez-nous</Link></p>
                <Link to="/contact" className="btn btn-primary">Obtenir un devis personnalisé</Link>
              </div>
            </div>
          </article>
        </div>
      </div>
    </>
  );
};

export default RecuperationDonnees;
